import {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import configActions from '../store/actions/config';
import {Link} from 'react-router-dom';
import {DropdownMenu} from './DropdownMenu';
import {useLocation} from 'react-router-dom';
import Payment from "./Payment/Payment";
import paymentActions from "../store/actions/payment"

export const Header = () => {
    const configStore = useSelector((store) => store.configStore);
    const paymentStore = useSelector((store) => store.paymentStore);
    const dispatch = useDispatch();

    const legacyPortalUrl = process.env.REACT_APP_SIGN_IN_URI || process.env.REACT_APP_LEGACY_PORTAL_URL || 'https://my.rvos.com';

    const handleOpenModal = () => {
        dispatch(paymentActions.setPaymentModalOpen(true));
        document.getElementsByTagName('body')[0].classList.add('modal-open');
    }

    const menuBlock = [
        {
            id: 0,
            isActive: false,
            name: 'Products',
            axisX: '0',
            values: [
                {
                    id: 0,
                    title: 'Farm and Ranch',
                    img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/farm.svg`,
                    url: '/products/farm_and_ranch'
                },
                {
                    id: 1,
                    title: 'Landlord',
                    img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/duplex.svg`,
                    url: '/products/landlord'
                },
                {
                    id: 2,
                    title: 'Home',
                    img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/house.svg`,
                    url: '/products/home_owners'
                },
                {
                    id: 3,
                    title: 'Organization',
                    img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/church.svg`,
                    url: '/products/organization'
                },
                {
                    id: 4,
                    title: 'Manufactured and Mobile Home',
                    img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/manufacturedhouse.svg`,
                    url: '/products/manufactured_and_mobile_home'
                }
            ]
        },
        {
            id: 1,
            isActive: false,
            name: 'Claims',
            url: '/claims'
        },
        {
            id: 2,
            isActive: false,
            name: 'Info Center',
            url: '/info-center'
        },
        {
            id: 3,
            isActive: false,
            name: 'About RVOS',
            axisX: '320px',
            values: [
                {
                    id: 0,
                    title: 'MyRVOS',
                    img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/myrvos.svg`,
                    url: '/about/my-rvos'
                },
                {
                    id: 1,
                    title: 'History of RVOS',
                    img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/star.svg`,
                    url: '/about/history'
                },
                {
                    id: 2,
                    title: 'Our Companies',
                    img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/company.svg`,
                    url: '/about/our-companies'
                },
                {
                    id: 3,
                    title: 'Newsletter',
                    img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/rolnik.svg`,
                    url: '/about/newsletter'
                },
                // {
                //     id: 4,
                //     title: 'Careers',
                //     img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers-link.svg`,
                //     url: '/careers'
                // }
            ]
        },
        {
            id: 4,
            isActive: false,
            name: 'Contact Us',
            url: '/contact-us'
        }
    ]

    const [isMenuOpened, setIsMenuOpened] = useState(false)
    const [itemMenu, setItemMenu] = useState([])
    const [topMenuBlock, setTopMenuBlock] = useState(menuBlock)
    const [axisX, setAxisX] = useState('')

    const [itemOpened, setItemOpened] = useState(null)
    let location = useLocation();

    const highLightMenuItem = (item = 0) => {
        const newMenuBlock = topMenuBlock
            .map(elem => ({...elem, isActive: false}))
            .map(elem => {
                if (elem.id === item.id) return {...elem, isActive: !elem.isActive}
                return elem
            })

        setTopMenuBlock(newMenuBlock)
    }

    const openMobileMenu = () => {
        dispatch(configActions.setMenuOpen(true));
        document.body.classList.add("mobile-menu-open")
    }
    const closeMobileMenu = () => {
        dispatch(configActions.setMenuOpen(false));
        setItemOpened(null);
        document.body.classList.remove("mobile-menu-open")
    }
    const toggleItem = (item) => {
        if (item === itemOpened) {
            setItemOpened(null);
        } else {
            setItemOpened(item)
        }
    }

    const clickMenuItem = item => {
        highLightMenuItem(item)
        if (item.values) {
            setItemMenu(item.values)
            setIsMenuOpened(true)
            setAxisX(item.axisX)
        }
    }

    const closeDropdownMenu = () => {
        setIsMenuOpened(false)
        highLightMenuItem()
    }



    useEffect(() => {
        let activeElem = document.querySelector('.lv2-item.active');

        document.querySelectorAll('.mobile-menu-item').forEach((el) => {
            el.classList.remove('active');
        });

        if (activeElem) {
            activeElem.closest('.mobile-menu-item').classList.add('active');
        }
    });


    return (
        <>
            <header>
                <div className="header-container" id="header-container">
                    <div className="left-side">
                        <div className='menu-icon' onClick={() => openMobileMenu()}>
                            <div className="line line-1"/>
                            <div className="line line-2"/>
                            <div className="line line-3"/>
                        </div>
                        <Link className={`main-logo ${location.pathname === '/' ? 'disabled' : ''}`} to="/">
                            <img className="logo-desktop" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/logo.svg`} alt=""/>
                            <img className="logo-mobile" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/logo-mobile.svg`} alt=""/>
                        </Link>
                        <menu>
                            {
                                isMenuOpened &&
                                <DropdownMenu
                                    closeDropdownMenu={closeDropdownMenu}
                                    values={itemMenu}
                                    axisX={axisX}
                                />
                            }
                            {
                                topMenuBlock.map(item => {
                                    return (
                                        <li
                                            key={item.id}
                                            onClick={(e) => clickMenuItem(item)}
                                            className={`${item.isActive ? 'active' : ''} ${item.url === location.pathname ? 'highlight' : ''}`}
                                        >
                                            {
                                                item.values ?
                                                    <div className='menu-item-name'>
                                                        {item.name}
                                                    </div> :
                                                    <Link to={item.url}>{item.name}</Link>
                                            }
                                            {
                                                item.values && <img
                                                    src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/arrow-dropdown.png`}
                                                    alt=""/>

                                            }
                                        </li>
                                    )
                                })
                            }
                        </menu>
                    </div>
                    <div className="right-side">
                        <a href={legacyPortalUrl} className="account" target="_blank" rel="noopener noreferrer">
                            <div className="account-text">My Account</div>
                            <img className="account-image" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icon-user.svg`} alt="ic-user"/>
                        </a>
                         <button type="button" className="btn-payment button-blue" onClick={handleOpenModal}>Make a Payment</button>
                    </div>
                </div>
                <div className={`mobile-menu ${configStore.isMenuOpen ? 'open' : ''}`}>
                    <div className="mobile-menu-overlay" onClick={() => closeMobileMenu()}/>
                    <div className="mobile-menu-block">
                        <div className="mobile-menu-heading">
                            <Link className={`mobile-menu-logo ${location.pathname === '/' ? 'disabled' : ''}`} to="/" onClick={() => closeMobileMenu()}>
                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/logo.svg`} alt=""/>
                            </Link>
                            <button type="button" className="mobile-menu-close" onClick={() => closeMobileMenu()}>
                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icon-close.svg`} alt=""/>
                            </button>
                        </div>
                        <div className="mobile-menu-account">
                            <a href={legacyPortalUrl} className="account" target="_blank" rel="noopener noreferrer" onClick={() => closeMobileMenu()}>
                                <img className="account-image" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icon-user.svg`} alt="ic-user"/>
                                <div className="account-text">My Account</div>
                            </a>
                        </div>
                        <div className="mobile-menu-content">
                            {
                                topMenuBlock.map(item => {
                                    return (
                                        <div
                                            key={item.id}
                                            className={`mobile-menu-item item-${item.id} ${item.values ? 'sub-in' : ''} ${item.id === itemOpened ? 'open' : ''}`}
                                        >
                                            <div className={`item-heading ${item.url === location.pathname ? 'active' : ''}`} >
                                                {
                                                    item.values ?
                                                        <div className='menu-item-name' onClick={() => toggleItem(item.id)}>
                                                            {item.name}
                                                        </div> :
                                                        <Link className='menu-item-name' to={item.url} onClick={() => closeMobileMenu()}>{item.name}</Link>
                                                }
                                                <img
                                                    className="item-heading-arrow"
                                                    src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/arrow-dropdown.png`}
                                                    alt=""/>
                                            </div>
                                            {
                                                item.values &&
                                                    <div className="menu-item-lv2">
                                                        {item.values.map(item => {
                                                            return <div className={`lv2-item ${item.url === location.pathname ? 'active' : ''}`} key={item.id} >
                                                                <Link onClick={() => closeMobileMenu()} to={item.url}>
                                                                    <img src={item.img} alt="icon" />
                                                                    <div className="title">
                                                                        {item.title}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        })}
                                                    </div>
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </header>
            {paymentStore.paymentModalOpen && <Payment/>}
        </>
    );
}
